import Swiper from '~node_modules/swiper';

import { Navigation, A11y, Keyboard } from '~node_modules/swiper/modules';

import '~node_modules/swiper/swiper.scss';
import '~node_modules/swiper/modules/a11y.scss';
import '~node_modules/swiper/modules/navigation.scss';
import '~node_modules/swiper/modules/keyboard.scss';

async function initSliders() {

    // init swipers
    const swiperSponsor1 = document.querySelectorAll('.swiper-sponsor-1');
    if (swiperSponsor1) {
        swiperSponsor1.forEach((swiper) => {
            new Swiper(swiper, {
                ...standardSettings,
                slidesPerView: 'auto',
                spaceBetween: 60,
                pagination: {
                    el: swiper.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiper.querySelector('.swiper-button-next'),
                    prevEl: swiper.querySelector('.swiper-button-prev'),
                },
            });
        });
    }


    const swiperSponsor2 = document.querySelectorAll('.swiper-sponsor-2');
    if (swiperSponsor2) {
        swiperSponsor2.forEach((swiper) => {
            new Swiper(swiper, {
                ...standardSettings,
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    992: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 4
                    }
                },
                pagination: {
                    el: swiper.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiper.querySelector('.swiper-button-next'),
                    prevEl: swiper.querySelector('.swiper-button-prev'),
                },
            });
        });
    }

    const swiperNews = document.querySelectorAll('.swiper-news');
    if (swiperNews) {
        swiperNews.forEach((swiper) => {
            new Swiper(swiper, {
                ...standardSettings,
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    992: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    1200: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    }
                },
                pagination: {
                    el: swiper.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiper.querySelector('.swiper-button-next'),
                    prevEl: swiper.querySelector('.swiper-button-prev'),
                },
            });
        });
    }
}

const standardSettings = {
    spaceBetween: 30,
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
    },
    watchSlidesProgress: true,
    a11y: {
        enabled: true,
        firstSlideMessage: 'Das ist die erste Folie',
        lastSlideMessage: 'Das ist die letzte Folie',
        prevSlideMessage: 'Vorherige Folie',
        nextSlideMessage: 'Nächste Folie',
        paginationBulletMessage: 'Gehe zuŕ Folie {{index}}',
        slideLabelMessage: 'Folie {{index}} von {{slidesLength}}',
        containerRole: 'region'
    },
    on: {
        beforeInit: function (swiper) {
            initShuffleSliders(swiper);
        },
        afterInit: function (swiper) {
            addEventListenerToPlayButton('.swiper-button-autoplay', swiper);
            addEventListenerToSwiper(swiper);
            addAriaLabelElementsToSlides(swiper);
        },
    },
    modules: [Navigation, A11y, Keyboard],
};

globalThis.initWeatherWarnings = () => {
    setTimeout(() => {
        document.querySelectorAll('.swiper-weather-warnings').forEach((swiper) => {
            if (swiper.classList.contains('_swiper-initialized')) return;
            swiper.classList.add('_swiper-initialized');

            new Swiper(swiper, {
                ...standardSettings,
                slidesPerView: 1,
                navigation: {
                    nextEl: swiper.querySelector('.swiper-button-next'),
                    prevEl: swiper.querySelector('.swiper-button-prev'),
                },
            });
        });
    }, 1);
};


function addAriaLabelElementsToSlides(swiper) {

    const sliderRoot = swiper.el;

    const slides = sliderRoot.querySelectorAll('.swiper-slide');

    slides.forEach(function (slide) {

        // create new dom element
        const focusableText = document.createElement('div');
        focusableText.classList.add('visually-hidden-focusable');
        focusableText.tabIndex = 0;
        focusableText.innerText = slide.getAttribute('aria-label');
        slide.insertBefore(focusableText, slide.firstChild);
        slide.removeAttribute('aria-label');

    });

}

function initShuffleSliders(swiper) {

    const sliderRoot = swiper.el;

    if (!swiper.el.classList.contains('swiper-shuffled')) { return; }

    let newHtmlContent = '';

    Array.from(sliderRoot.querySelectorAll('.swiper-wrapper .swiper-slide'))
        // add random number to each element
        .map(value => ({ value, sort: Math.random() }))
        // sort by random number
        .sort((a, b) => a.sort - b.sort)
        // set style order by index
        .map(({ value }) => value)
        .forEach((el, index) => {
            newHtmlContent += el.outerHTML;
        });

    sliderRoot.querySelector('.swiper-wrapper').innerHTML = newHtmlContent;

    sliderRoot.classList.remove('swiper-hidden');
}


function addEventListenerToSwiper(swiper) {

    const swiperContainer = swiper.el;

    const swiperSlides = swiper.el.querySelectorAll('.swiper-slide, .swiper-pagination-bullet, .swiper-navigation > *, .swiper-slide a');
    swiperSlides.forEach(function (slide) {
        slide.addEventListener('focusin', function (event) {
            if (swiperContainer.contains(document.activeElement)) {
                if (swiper.autoplay.running) {
                    swiper.autoplay.pause();
                }
            }
        });

        slide.addEventListener('focusout', function (event) {
            if (!swiperContainer.contains(event.relatedTarget)) {
                swiper.autoplay.start();
            }
        });
    });
    const paginationBullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
    paginationBullets.forEach(function (bullet, index) {
        bullet.addEventListener('keydown', function (event) {
            if (swiperContainer.contains(document.activeElement)) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                    bullet.click();
                }
            }
        });
        bullet.addEventListener('click', function () {
            const focusElement = swiper.slides[index].querySelector('.visually-hidden-focusable');
            if (focusElement) {
                focusElement.focus();
            }
        });
    });

}

function addEventListenerToPlayButton(el, swiper) {
    const element = swiper.el.querySelector(el);

    // check for resize event
    initDisplayConditionForPlaybutton(element, swiper);

    if (element) {
        element.addEventListener('click', function (event) {
            if (element.classList.contains('is-active')) {
                swiper.autoplay.stop();
                element.classList.remove('is-active');
            } else {
                swiper.autoplay.start();
                element.classList.add('is-active');
            }
        });
    }

}

function initDisplayConditionForPlaybutton(element, swiper) {

    if (swiper.isBeginning && swiper.isEnd) {
        element.classList.add('d-none');
    } else {
        element.classList.remove('d-none');
    }
    window.addEventListener('resize', function () {
        if (swiper.isBeginning && swiper.isEnd) {
            element.classList.add('d-none');
        } else {
            element.classList.remove('d-none');
        }
    });
}

export { initSliders };
